import {BaseComponent, ConfirmOperationHandler} from "framework/ui/components";
import {NotificationPopupComponent, NotificationType} from "framework/ui/notification-popup/notification-popup.component";

export class ConfirmOperationHandlerImpl implements ConfirmOperationHandler
{
    confirm(base: BaseComponent,
            text: string,
            title?: string): Promise<boolean>
    {
        return NotificationPopupComponent.open(base,
                                               NotificationType.WarningWithAction,
                                               title || "Are you sure?",
                                               "cs-icon-alert-circle",
                                               [text], [
                                                   {
                                                       label   : "No",
                                                       priority: "tertiary",
                                                       action  : async () => false
                                                   },
                                                   {
                                                       label   : "Yes",
                                                       priority: "primary",
                                                       action  : async () => true
                                                   }
                                               ]);
    }
}
